import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function PlatformAdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get('/api/platform_admin/auth/me', { withCredentials: true })
      .then((res) => {
        if (res.data && res.data.is_platform_admin) {
          window.location.href = '/platform_admin';
        }
      })
      .catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const form = new URLSearchParams();
    form.append('username', username);
    form.append('password', password);

    try {
      const res = await axios.post('/api/platform_admin/login', form, {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });

      const data = res.data || {};
      if (data.ok && data.redirect) {
        window.location.href = data.redirect;
        return;
      }
    } catch (err) {
      const data = err?.response?.data || {};
      setError(data.error || '아이디 또는 비밀번호가 잘못되었습니다.');
    }
  };

  return (
    <div className="p-4">
      <div className="container" style={{ maxWidth: '400px' }}>
        <h2 className="mb-4">플랫폼 관리자 로그인</h2>

        {error ? <div className="alert alert-danger">{error}</div> : null}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label>아이디</label>
            <input
              type="text"
              name="username"
              className="form-control"
              required
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label>비밀번호</label>
            <input
              type="password"
              name="password"
              className="form-control"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button type="submit" className="btn btn-primary w-100">로그인</button>
        </form>
      </div>
    </div>
  );
}